import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addpaymentmode',
  templateUrl: './addpaymentmode.component.html',
  styleUrls: ['./addpaymentmode.component.css']
})
export class AddpaymentmodeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  paymentmodeColl: any = [];
  paymentmodelistColl: any = [];

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  paymentmodeform = new FormGroup({
    paymentmodeid: new FormControl(0),
    paymentmodename: new FormControl('', Validators.required),
    paymentmodelist: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Paymentmode";

  @Input() paymentmodeid: number = 0
  @Input() paymentmodename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.paymentmodeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.paymentmodeform.reset();
      this.fnInitializePaymentmode();

      if (this.paymentmodeid > 0) {
        this.fngetPaymentmode();
      }
      this.fngetPaymentmodeList();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.paymentmodeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializePaymentmode() {
    this.paymentmodeform.setValue({

      paymentmodeid: 0,
      paymentmodename: '',
      paymentmodelist: '',
      inactive:false,
    })
  }
  fngetPaymentmodeList() {

    this.paymentmodelistColl = [];
    this.paymentmodelistColl.push({ value: 'CARD', displayname: 'Card' });
    this.paymentmodelistColl.push({ value: 'CASH', displayname: 'Cash' });
    this.paymentmodelistColl.push({ value: 'NCKOT', displayname: 'Nckot' });
   
  }
  //Get 
  fngetPaymentmode() {
   
    var data = {
      'paymentmodeid': this.paymentmodeid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPaymentmode(data)
      .subscribe(
        (res) => {
          this.paymentmodeColl = res.json().result;
          var editdata = this.paymentmodeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.paymentmodeform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'paymentmodeid': this.paymentmodeid,
          'paymentmodename': this.paymentmodeform.get('paymentmodename').value,
          'paymentmodelist': this.paymentmodeform.get('paymentmodelist').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.paymentmodeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckPaymentmode(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.paymentmodeform.get('paymentmodeid').value > 0) {
                //Update Department
                this.fnSetPaymentmode(data);
              }
              else {
                //Insert Department
                this.fnInsertPaymentmode(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false

                this.paymentmodeform.controls['paymentmodename'].setErrors({ 'notfound': true });
              }
              else if(_checkresult === "list") {
                this.saveloading=false

                this.paymentmodeform.controls['paymentmodelist'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertPaymentmode(data) {

    this.appService.fnInsertPaymentmode(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The New Paymentmode has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.paymentmodeid);

          this.emitData.emit(this.paymentmodeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetPaymentmode(data) {

    this.appService.fnSetPaymentmode(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The paymentmode has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.paymentmodeid, data.paymentmodename);

          this.emitData.emit(this.paymentmodeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.paymentmodeform.setValue({

      paymentmodeid: deptBO.paymentmodeid,
      paymentmodename: deptBO.paymentmodename,
      paymentmodelist: deptBO.paymentmodelist,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
